import SchedulesService from 'js/services/api/schedules/schedules.js'
import template from './index.pug'

// @vue/component
export default Vue.extend({
  name: 'schedules-page',
  template: template(),
  props: {
    route: {
      type: Object
    }
  },

  data() {
    return {
      date: moment().toDate(),
      schedules: []
    }
  },
  computed: {
    datepickerConfig() {
      const currentLocale = Vue.i18n.locale;
      const calendarLocales = Vue.i18n.locales || {};

      return {
        allowInput: true,
        formatDate(date) { return moment(date).format('DD/MM/YYYY') },
        parseDate(date) { return moment(date, 'DD/MM/YYYY').toDate() },
        disableMobile: true,
        locale: calendarLocales[currentLocale] || 'default'
      }
    }
  },
  watch: {
    date() {
      this.getSchedules()
    }
  },

  created() {
    this.getSchedules()
  },

  methods: {
    async getSchedules() {
      const calendarParams = {date: this.date.toString(), subline_id: this.route.subline_id}

      // Obtenemos los calendarios filtrando por sublinea y fecha
      const response = await SchedulesService.getCalendar(calendarParams)
      // Obtenemos los ids de los calendarios
      const calendars = response.map(calendar => calendar.id)

      if (calendars.length) {
        // Si hemos obtenido uno o más calendarios, obtenemos los journeys filtrando por ruta y
        // calendarios
        this.schedules = await SchedulesService.getJourneys(
          {
            calendar_ids: calendars,
            route_id: this.route.id,
            order_by: 'journey_hours,journey_minutes,journey_seconds',
            active: true,
            per: 0
          }
        )
      } else {
        this.schedules = []
      }
    }
  }
})
